import React, { useState, useEffect } from 'react';
import './custom.css';
import { getApiUrl } from './ApiUtil';
import Cookies from 'js-cookie';

export function UserNotFound() {


    return (
        <div >
            <h2 className="authTitle">Authorization to Travel While Absent from Work</h2>
            <div className="divider"></div>
            <div className="travel-authorization-form">
                <h3>Your user id was not found in the database. </h3>

                <p>If you have encountered this error and you are not a Piedmont or contract employee, please contact Andrew.Corry@aa.com.</p>
                
            </div>
        </div>
    );
}

export default UserNotFound;
